export default {
  quote_request_management: ['quote_request_management'],
  quote_request_add: ['quote_request_add'],
  quote_request_edit: ['quote_request_edit'],
  quote_request_delete: ['quote_request_delete'],
  quote_request_archive: ['quote_request_archive'],
  quote_request_restore: ['quote_request_restore'],
  quote_request_activity: ['quote_request_activity'],

  quote_management: ['quote_management'],
  quote_add: ['quote_add'],
  quote_edit: ['quote_edit'],
  quote_view_detail: ['quote_view_detail'],
  quote_view_detail_quote_request: ['quote_view_detail_quote_request'],
  quote_view_detail_quote_internal: ['quote_view_detail_quote_internal'],
  quote_price_information: ['quote_price_information'],
  quote_delete: ['quote_delete'],
  quote_archive: ['quote_archive'],
  quote_restore: ['quote_restore']
}
